"use client";

import { useEffect } from "react";
import { useSearchParams, useRouter } from "next/navigation";
import { useSession } from "next-auth/react";
import { sendGTMEvent } from "@next/third-parties/google";

export function AuthSuccessTracker() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const { data: session } = useSession();

  useEffect(() => {
    const isAuthSuccess = searchParams.get("auth_success");
    const provider = searchParams.get("provider");

    if (isAuthSuccess === "true" && provider && session?.user) {
      sendGTMEvent({
        event: "auth_success",
        provider,
        user_id: session.userId,
      });

      const url = new URL(window.location.href);
      url.searchParams.delete("auth_success");
      url.searchParams.delete("provider");
      router.replace(url.pathname, { scroll: false });
    }
  }, [searchParams, router, session]);

  return null;
}
